module.exports = __webpack_public_path__ + "img/Matt Macey.350cc141.png";